// Maps keys with null values to rather be considered undefined - one-dimensional
export const mapNullsToUndefinedOneDimensional = (object: object) =>
  Object.entries(object).reduce(
    (acc: object, [key, value]) => ({
      ...acc,
      [key]: value === null ? undefined : value,
    }),
    {},
  );

// Maps keys with null values to rather be considered undefined - multi-dimensional
const mapNullsToUndefined = (object: object): object =>
  Object.entries(object).reduce(
    (acc: object, [key, value]) => ({
      ...acc,
      [key]: value === null ? undefined : mapNullsIfObject(value),
    }),
    {},
  );

const mapNullsIfObject = (value: unknown | object): unknown | object =>
  typeof value === 'object' && !Array.isArray(value) && value !== null
    ? mapNullsToUndefined(value)
    : value;

export default mapNullsToUndefined;
